"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ragusa": {
    "5ecdfd30": [{
      "hkey": "09729963",
      "slug": "americhe-panetti",
      "name": "Americhe-Panetti",
      "primary": true,
      "skipSearch": false
    }],
    "beddio-gesuiti-pianetti": [{
      "hkey": "09729963",
      "slug": "americhe-panetti",
      "name": "Americhe-Panetti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b5f3e2f6": [{
      "hkey": "7e718b72",
      "slug": "busce-cisternazzi",
      "name": "Buscè-Cisternazzi",
      "primary": true,
      "skipSearch": false
    }],
    "brusce": [{
      "hkey": "7e718b72",
      "slug": "busce-cisternazzi",
      "name": "Buscè-Cisternazzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1b5cf6b0": [{
      "hkey": "affaac8d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cappuccini": [{
      "hkey": "affaac8d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ragusa"
    }],
    "2473517b": [{
      "hkey": "6a70d8ce",
      "slug": "selvaggio",
      "name": "Selvaggio",
      "primary": true,
      "skipSearch": false
    }],
    "cupoletti": [{
      "hkey": "6a70d8ce",
      "slug": "selvaggio",
      "name": "Selvaggio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ragusa"
    }],
    "e96c764d": [{
      "hkey": "affaac8d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "ecce-homo": [{
      "hkey": "affaac8d",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ragusa"
    }],
    "3eb39603": [{
      "hkey": "bb4fccc5",
      "slug": "archimede-san-luigi-viale-europa",
      "name": "Archimede-San Luigi-Viale Europa",
      "primary": true,
      "skipSearch": false
    }],
    "viale-europa": [{
      "hkey": "bb4fccc5",
      "slug": "archimede-san-luigi-viale-europa",
      "name": "Archimede-San Luigi-Viale Europa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "964dafd5": [{
      "hkey": "bb4fccc5",
      "slug": "archimede-san-luigi-viale-europa",
      "name": "Archimede-San Luigi-Viale Europa",
      "primary": true,
      "skipSearch": false
    }],
    "villa-pax": [{
      "hkey": "bb4fccc5",
      "slug": "archimede-san-luigi-viale-europa",
      "name": "Archimede-San Luigi-Viale Europa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ragusa"
    }]
  }
};
exports["default"] = _default;